<template>
  <div class="base">
    <account-header jump-user-type="user" />
    <div class="main">
      <div class="panel">
        <div>
          <div class="panno" />
        </div>
        <div class="title">
          教员注册
        </div>
        <div class="form-panel">
          <a-form :form="form" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" @submit="handleSubmit">
            <a-alert v-if="registerError" type="error" show-icon style="margin-bottom: 24px;"
              :message="registerErrorMessage" />
            <a-form-item>
              <a-input v-decorator="[
                'username',
                {
                  rules: [
                    { required: true, message: '用户名不能为空' },
                    {
                      pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/g,
                      message: '用户名只能包含汉字和字母'
                    },
                    { min: 3, message: '用户名不小于3个字符' },
                    {
                      validator: (rules, value, callback) => {
                        handleCheckUsername(rules, value, callback)
                      }
                    }
                  ],
                  validateTrigger: ['blur']
                }
              ]" size="large" :autocomplete="false" placeholder="设置登录用户名（只能包含汉字和字母，长度3~20）">
                <a-tooltip v-if="username_available" slot="suffix" title="用户名可用">
                  <a-icon type="check-circle" class="theme-color" />
                </a-tooltip>
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input-password v-decorator="[
                'password',
                {
                  rules: [
                    {
                      validator: (rules, value, callback) => {
                        handleCheckPwd(rules, value, callback)
                      }
                    }
                  ],
                  validateTrigger: ['change', 'blur']
                }
              ]" size="large" placeholder="设置你的登录密码" autocomplete="new-password" />
            </a-form-item>
            <a-form-item>
              <a-input-password v-decorator="[
                'pwd_confirm',
                {
                  rules: [
                    {
                      validator: (rules, value, callback) => {
                        handleCfmPwd(rules, value, callback)
                      }
                    }
                  ],
                  validateTrigger: ['change', 'blur']
                }
              ]" size="large" placeholder="再次输入密码" autocomplete="false" :visibility-toggle="false" />
            </a-form-item>
            <a-form-item>
              <a-input v-decorator="[
                'phone',
                {
                  rules: [
                    {
                      required: true,
                      message: '手机号不能为空'
                    },
                    {
                      pattern: /^1[3-9][0-9]\d{8}$/,
                      message: '手机号格式错误'
                    },
                    {
                      validator: (rules, value, callback) => {
                        handleCheckPhone(rules, value, callback)
                      }
                    }
                  ],
                  validateTrigger: ['blur']
                }
              ]" size="large" placeholder="设置你的手机号" type="number">
                <a-tooltip v-if="phone_available" slot="suffix" title="手机号可用">
                  <a-icon type="check-circle" class="theme-color" />
                </a-tooltip>
              </a-input>
            </a-form-item>
            <a-form-item v-if="false">
              <a-row :gutter="16">
                <a-col :span="16">
                  <a-input v-decorator="[
                    'captcha_value',
                    {
                      rules: [
                        { required: true, message: '请输入图形验证码' },
                        { min: 4, message: '验证码长度不小于4个字符' }
                      ]
                    }
                  ]" size="large" placeholder="图形验证码" />
                </a-col>
                <a-col :span="8">
                  <img style="cursor: pointer" width="80px" height="100%" :src="captcha_img_str" alt=""
                    @click="loadVerify">
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item>
              <a-input v-decorator="[
                'phone_captcha_code',
                {
                  rules: [
                    { required: true, message: '请输入短信验证码' },
                    { min: 4, message: '验证码长度不小于4个字符' }
                  ]
                }
              ]" size="large" placeholder="手机验证码" />
              <a-button :disabled="state.getCodeBtn" type="link" class="get-code-btn" size="large"
                @click="handleGetPhoneCode">
                {{ lastTimeContent }}
              </a-button>
            </a-form-item>
            <a-form-item>
              <a-input v-decorator="[
                'referral_code',
                {
                  initialValue: promo_code
                }
              ]" size="large" placeholder="推广码" autocomplete="false" :visibility-toggle="false" />
            </a-form-item>
            <a-form-item>
              <div style="text-align: left;">
                <a-checkbox v-decorator="[
                  'accept',
                  {
                    valuePropName: 'checked',
                    rules: [
                      { required: true, message: '请阅读并同意服务条款' }
                    ]
                  }
                ]" size="large" />
                <a class="color-grey" target="_blank" href="/article/info/12">《教员服务协议》</a>
                <a class="color-grey" target="_blank" href="/article/info/7">《法律声明和隐私政策》</a>
              </div>
            </a-form-item>
            <a-form-item>
              <a-button :loading="state.registerBtn" :disabled="state.registerBtn" size="large" type="primary"
                html-type="submit" block>
                同意条款并注册
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
    <account-footer />
  </div>
</template>

<script>
import { AccountHeader, AccountFooter } from '@/components'

export default {
  name: 'TeacherRegister',
  description: '这是描述信息',
  components: {
    AccountHeader,
    AccountFooter
  },
  props: {
    promo_code: {}
  },
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      captcha_key: '',
      captcha_value: '',
      captcha_img_str: '',
      username_available: false,
      phone_available: false,
      lastTimeContent: '获取验证码',
      state: {
        registerBtn: false,
        getCodeBtn: false
      },
      registerError: false,
      registerErrorMessage: ''
    }
  },
  created() {
    this.loadVerify()
  },
  methods: {
    loadVerify() {
      this.$http({
        url: '/index/index/captcha',
        method: 'get'
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          this.captcha_key = res.data.captcha_key
          this.captcha_value = res.data.captcha_value
          this.captcha_img_str = res.data.img_str
        } else {
          this.$toast.fail('获取验证码失败')
        }
      })
    },
    handleSubmit(e) {
      // 注册
      e.preventDefault()
      const { form, state } = this
      this.registerError = false
      form.validateFields((err, values) => {
        if (!err) {
          this.state.registerBtn = true
          this.$http({
            url: '/index/teacher_account/register',
            method: 'post',
            data: values
          })
            .then(res => {
              if (res.status === 'success') {
                this.$toast.success('账号注册成功，跳转登录')
                setTimeout(() => {
                  this.$router.push({ path: '/account/teacher-login' })
                }, 3000)
              } else {
                this.registerError = true
                this.registerErrorMessage = res.message
              }
            })
            .finally(() => {
              state.registerBtn = false
            })
        }
      })
    },
    handleGetPhoneCode() {
      // 获取短信验证码
      const that = this
      this.form.validateFields(['phone', 'captcha_value'], (err, values) => {
        if (!err) {
          values.captcha_key = this.captcha_key
          values.captcha_value = this.captcha_value
          that.state.getCodeBtn = true
          // 按钮变灰，倒计时
          new Promise((resolve, reject) => {
            this.$http({
              url: '/index/teacher_account/registerGetVerifyCode',
              method: 'post',
              data: values
            }).then(response => {
              if (response.status === 'success') {
                resolve(response)
              } else {
                reject(response)
              }
            })
          })
            .then(res => {
              const data = res.data
              let lastTime = data.count_down
              const timer = setInterval(() => {
                if (lastTime > 0) {
                  this.lastTimeContent = lastTime + 's'
                  lastTime--
                } else {
                  window.clearInterval(timer)
                  this.lastTimeContent = '发送验证码'
                  that.state.getCodeBtn = false
                }
              }, 1000)
              // 倒计时
            })
            .catch(error => {
              that.state.getCodeBtn = false
              // 设置错误信息到验证码输入框下
              that.form.setFields({
                captcha_value: {
                  value: values.captcha_value,
                  errors: [new Error(error.message)]
                }
              })
              // 刷新验证码
              that.loadVerify()
            })
        }
      })
    },
    handleCheckUsername(rules, value, callback) {
      this.username_available = false
      const that = this
      if (value !== undefined && value.length >= 6) {
        const data = {}
        data.username = value
        new Promise((resolve, reject) => {
          this.$http({
            url: '/index/teacher_account/checkUsernameExists',
            method: 'post',
            data: data
          }).then(response => {
            if (response.status === 'success') {
              resolve(response)
            } else {
              reject(response)
            }
          })
        })
          .then(() => {
            that.username_available = true
            callback()
          })
          .catch(error => {
            callback(new Error(error.message))
            that.username_available = false
          })
      } else {
        callback()
      }
    },
    handleCheckPhone(rules, value, callback) {
      this.phone_available = false
      const that = this
      if (value !== undefined && value.length === 11) {
        const data = {}
        data.phone = value
        new Promise((resolve, reject) => {
          this.$http({
            url: '/index/teacher_account/checkPhoneExists',
            method: 'post',
            data: data
          }).then(response => {
            if (response.status === 'success') {
              resolve(response)
            } else {
              reject(response)
            }
          })
        })
          .then(() => {
            that.phone_available = true
            callback()
          })
          .catch(error => {
            callback(new Error(error.message))
            that.phone_available = false
          })
      } else {
        callback()
      }
    },
    handleCheckPwd(rules, value, callback) {
      if (value === undefined) {
        callback(new Error('请输入密码'))
      }
      var cfmPwd = this.form.getFieldValue('pwd_confirm')
      const PassWordRegex = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,20}$/
      if (!PassWordRegex.test(value)) {
        callback(new Error('密码至少包含字母和数字，并且长度在8~30'))
      }
      if (cfmPwd && cfmPwd !== value) {
        callback(new Error('两次密码输入不一致'))
      } else {
        // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
        callback()
      }
    },
    handleCfmPwd(rules, value, callback) {
      if (value === undefined) {
        callback(new Error('请再次输入你的密码'))
      }
      var password = this.form.getFieldValue('password')
      if (password && password !== value) {
        callback(new Error('两次密码输入不一致'))
      } else {
        // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
        callback()
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.base {
  min-width: 280px;
  max-width: 420px;
  margin: auto;
  background-color: #fff;
}

.main {
  padding: 15px;

  .panel {
    background-color: #ffffff;
    box-shadow: 1px 3px 16px 0px rgba(34, 23, 20, 0.1);
    border-radius: 10px;
    padding: 15px;
    overflow: hidden;
    margin-top: 15%;

    .panno {
      width: 75px;
      height: 10px;
      background-color: #fa750d;
      border-radius: 9px;
      position:relative;
      top:-18px;
      margin:auto;
    }

    .title {
      text-align:center;
      margin-top:8%;
      font-family: PingFang-SC-Bold;
      font-size: 18px;
      line-height: 21px;
      color: #333333;
      font-weight: bold;
    }
  }

  .form-panel {
    text-align: left;
    margin-top: 40px;

    .get-code-btn {
      position: absolute;
      right: 0;
    }
  }
}
</style>
